import Vue from 'vue'
import axios from 'axios'
import { format, isBefore, parse } from 'date-fns'

export const MATCH_STATUSES = {
  finished: 'finished',
  live: 'live',
  upcoming: 'upcoming',
}

const calculateMatchStatus = (now, start, isActive) => {
  if (isBefore(now, start)) {
    return MATCH_STATUSES.upcoming
  }
  if (isActive) {
    return MATCH_STATUSES.live
  }
  return MATCH_STATUSES.finished
}

export const processMatch = (match, now) => {
  const start = parse(match.start)
  return {
    ...match,
    start,
    startFormatted: format(start, 'D.M.'),
    status: calculateMatchStatus(now, start, match.active),
  }
}

// state
export const state = {
  isMatchStatsLoading: false,
  selectedMatch: false,
  all: {},
}

// getters
export const getters = {
  getMatchStats: ({ all }, getters, { route: { params: { matchId } } }) => all[matchId] || [],
}
// mutations
export const mutations = {
  fetchMatchStatsStarted(state) {
    state.isMatchStatsLoading = true
  },
  fetchMatchStatsSuccess(state, { matchId, stats }) {
    Vue.set(state.all, matchId, stats)
    state.isMatchStatsLoading = false
  },
  fetchMatchStatsFailed(state) {
    state.isMatchStatsLoading = false
  },
}
// actions
export const actions = {
  async fetchMatchStats({ commit, state: { all } }, { matchId }) {
    if (typeof all[matchId] !== 'undefined') {
      return all[matchId]
    }
    let stats = null
    try {
      commit('fetchMatchStatsStarted')
      stats = await axios.get(`match/${matchId}/stats`)
      commit('fetchMatchStatsSuccess', {
        matchId,
        stats,
      })
    } catch (e) {
      commit('fetchMatchStatsFailed')
    }
    return stats
  },
}
